module.exports = __webpack_public_path__ + "img/ch13_13_二维码风波.2100262b.jpg";